export const ApplicationImages = [
    "https://s3.amazonaws.com/sygrin/application-page-photo-1.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-2.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-3.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-4.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-5.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-6.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-7.png",
    "https://s3.amazonaws.com/sygrin/application-page-photo-8.png",
];